import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { accountInitialValues } from 'components/organisms/forms/account/AccountForm';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useDeleteAccount,
  useGetAccount,
  usePostLicenseFromMagellan,
} from 'services/accounts';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const Account = () => {
  const accountId = useParamId('account');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getAccount = useGetAccount(accountId);
  const deleteAccount = useDeleteAccount(accountId);

  const setLicenseFromMagellan = usePostLicenseFromMagellan();

  const lastTab = pathname.split('/').pop();

  const onSetLicenseFromMagellan = async () => {
    await setLicenseFromMagellan.mutateAsync(accountId, {
      onError: error => onErrorShowAllErrorsToast(error),
      onSuccess: async () => await getAccount.refetch(),
    });
  };
  const onRemoveAccount = async () => {
    await deleteAccount.mutateAsync(undefined, {
      onError: error => onErrorShowAllErrorsToast(error),
      onSuccess: () => navigate('/account'),
    });
  };

  return (
    <Form.Accounts
      i18nextPrefix='account'
      initialValues={
        getAccount.data
          ? middleware.account.queryToForm(getAccount.data)
          : accountInitialValues
      }
      onSubmit={() => {}}
      tittle={getAccount.data?.accountName ?? '...'}
      status={{ displayMode: true, isLoading: getAccount.isLoading }}
      topbarContent={
        <div className='flex items-center gap-2'>
          <Button
            isClear
            onlyIcon
            disabled={!getAccount.data}
            onClick={() => {
              getAccount.data &&
                navigate(`/account/edit/${accountId}/${lastTab}`, {
                  replace: true,
                });
            }}>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>

          <MagellanPopups.DeleteWarning
            name={getAccount.data?.accountName}
            onRemove={onRemoveAccount}
          />
          <Button
            onClick={onSetLicenseFromMagellan}
            isLoading={setLicenseFromMagellan.isPending}>
            <Button.Text text='Set from magellan' />
          </Button>
        </div>
      }
    />
  );
};

export default Account;
